"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _base = require("@mui/base");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _user = require("../../store/user");
var _course = require("../../store/course");
var _materialEx = require("../../components/material-ex");
var _Style = require("../../style/Style");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = () => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setIsLoading,
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    currentUser,
    users,
    errors,
    fetchUsers,
    deleteUser
  } = (0, _user.useUserStore)();
  const {
    courses,
    fetchCourses
  } = (0, _course.useCourseStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      setIsLoading(true);
      await fetchCourses();
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u53D7\u8B1B\u72B6\u6CC1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: () => {
          setToastText('現在この機能はご利用できません。');
          setToastOpen(true); // setLocation('/user/add');
        },
        children: "\u53D7\u8B1B\u8005\u3054\u3068\u306E\u53D7\u8B1B\u72B6\u6CC1"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      justifyContent: 'space-between',
      direction: 'row',
      ...stylex.props(_Style.wrapper.stretchW),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
        direction: 'column',
        flexBasis: '48%',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: "\u4F01\u696D\u5168\u4F53\u306E\u4FEE\u4E86\u7387"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: "84%"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
        direction: 'column',
        flexBasis: '48%',
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: "\u53D7\u8B1B\u6642\u9593"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: "1,234\u6642\u9593"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h2),
        children: "\u53D7\u8B1B\u30B3\u30FC\u30B9"
      })
    }), courses.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Table, {
        sx: {
          tableLayout: 'fixed'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableHead, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u30B3\u30FC\u30B9\u540D"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u53D7\u8B1B\u7387"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u53D7\u8B1B\u6642\u9593"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {
              children: "\u53D7\u8B1B\u8005\u6570"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableHeaderCell, {})]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TableBody, {
          children: courses.map(course => {
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_materialEx.TableRow, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: course.name
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: "50%"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: "1,200\u6642\u9593"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                children: "23\u4EBA"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialEx.TableCell, {
                isCenter: true,
                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Stack, {
                  spacing: 2,
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {
                      setLocation('/status/course/' + course.id);
                    },
                    children: "\u53D7\u8B1B\u72B6\u6CC1"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
                    ...stylex.props(_Style.buttonStyle.secondary),
                    onClick: () => {// setLocation('/users/edit-email/' + user.id)
                    },
                    children: "\u53D7\u8B1B\u72B6\u6CC1CSV\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9"
                  })]
                })
              })]
            });
          })
        })]
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ...stylex.props(_Style.textStyle.p1b),
      children: errors.list || '該当するユーザーが存在しません'
    })]
  });
};
var _default = exports.default = App;